import type { Country } from '@kitopi-com/customer-auth';

interface Site {
  desc: string;
  name: string;
  countryCode: Country;
}

export const sites: Site[] = [
  {
    desc: 'UAE-CircleCafe-Baysquare',
    name: '7fh2s40v',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-Irise',
    name: 'zotqpl9i',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-AD7',
    name: 'd4nd3mqo',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-Mirdif',
    name: '7wyjudqe',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-Mangrove',
    name: '18jfq4de',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-StudioCity',
    name: 'ro1pngrh',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-StudioCity',
    name: 'npiosai2',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-DIFC',
    name: 'lravwgth',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-YasMall',
    name: '7z52amdf',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-Saadiyat',
    name: '8vkzaf2t',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-SushiNyu-Saadiyat',
    name: '0gqjee2e',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-DIFC',
    name: 'kngawbka',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-MediaCity',
    name: 'fefig41t',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-SushiCounter-MediaCity',
    name: 'q7vjw5au',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-MOE',
    name: 'jaf3chk8',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-DHCC',
    name: 'aq0p9eve',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-GateAvenue',
    name: 'olcvuuqh',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Katsu & Co-DIFC',
    name: 'hlgc0kjy',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-KiteBeach',
    name: '53yjhsfd',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-KiteBeach',
    name: 'g7cc2hqp',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-MediaCity',
    name: '9amiu8vj',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-JIP',
    name: 'wzhqa35n',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-DubaiMall',
    name: 'kl3y9ooy',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-Jafza-WH',
    name: 'vwxys7s4',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-R&D Office-Alquoz',
    name: 'n4l8va20',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-CK2',
    name: 'dnwo6zea',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-CK1',
    name: 'xn34u57g',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-CK3',
    name: '18gx2du2',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-Ajman',
    name: 'nyrmrvtq',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-Alain',
    name: 'rxv2wln9',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-JVC',
    name: 'xnc5p0dz',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-Muweillah',
    name: 'fugvn93o',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-Satwa',
    name: 'xe75o99d',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-Tecom',
    name: '1wbf3xwo',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-Zahiyah',
    name: 't8ykoz8z',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-Container',
    name: 'bgz1jh8o',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-Motorcity3',
    name: '3lfqar5k',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Pizzaro-AlShaab',
    name: 'ts70kmo9',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Pizzaro-Arjan',
    name: 'kinqq6qr',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Pizzaro-EmiratesZOO',
    name: 'lh73sxm5',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Pizzaro-KhalifaCity',
    name: 'kufd6olo',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-BiryaniPot-Baniyas',
    name: '1fbgekbl',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Biryanipot-Galleria',
    name: '26l4aqvw',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-BiryaniPot-Alain',
    name: 'mmzqts34',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-DSOWH-1',
    name: 'epiz9v0j',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-800Pizza-Marina',
    name: 'tvd05d0u',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-Marina2',
    name: 'tjqgwuit',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-Marina3',
    name: 'wyj83t0x',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-DSO2',
    name: '7azvxpwc',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-Mediacity',
    name: '8ozuflrw',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-SHJ1',
    name: 'rya32569',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-BB4',
    name: 'emqnirv4',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-Hessa',
    name: 'mw5lz08o',
    countryCode: 'AE',
  },
  {
    desc: 'BH-Kitopi-Juffair',
    name: 'vhfk88a3',
    countryCode: 'BH',
  },
  {
    desc: 'BH-Kitopi-ArganVillage',
    name: 'wg8cr71f',
    countryCode: 'BH',
  },
  {
    desc: 'BH-Kitopi-Adliya',
    name: 'd9pvwcli',
    countryCode: 'BH',
  },
  {
    desc: 'BH-Kitopi-SaarMall',
    name: 'vafx1fbj',
    countryCode: 'BH',
  },
  {
    desc: 'QAT-DietHouse-Azizya',
    name: 'hgbij4zz',
    countryCode: 'QA',
  },
  {
    desc: 'KSA-Kitopi-OF-JED-Sultan',
    name: 'ihqx4ijs',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Qurtuba',
    name: 'w5ubi0t6',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-HQ',
    name: '3a9z0abt',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Olaya',
    name: 'kgzo86tt',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Laban',
    name: '3p2fm8fz',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Riyadh-WH',
    name: 'gdr1bugh',
    countryCode: 'SA',
  },
  {
    desc: 'QAT-DietHouse-ALWakra',
    name: '0yy8tuag',
    countryCode: 'QA',
  },
  {
    desc: 'KSA-Kitopi-Zahra',
    name: '4h4p5wn3',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Manar',
    name: 'z9ihp6i9',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Spice',
    name: 'uwhqcr0r',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Wokkong Aqiq',
    name: 'ry70gvr3',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Wokkong-Rawabi',
    name: 'jugzpbj0',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Wokkong-Yarmuk',
    name: '8s1dcqji',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Wokkong-Yasmin',
    name: '6sbpcc2o',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Wokkong Maazer',
    name: 'nl8ken8f',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Wokkong Nuzhah',
    name: 'e8jdeif9',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-ext7',
    name: '5o8d8jd9',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-Wokkong-Albadiah',
    name: 'vmildox7',
    countryCode: 'SA',
  },
  {
    desc: 'QAT-DietHouse-Ummsalal',
    name: 'xvhrcrif',
    countryCode: 'QA',
  },
  {
    desc: 'UAE-PokePoke-DIFC',
    name: 'rr83ahii',
    countryCode: 'AE',
  },
  {
    desc: 'KWT-Kitopi-Jahara',
    name: 'd0ixuh54',
    countryCode: 'KW',
  },
  {
    desc: 'KWT-Kitopi-Sharq',
    name: 'cuwgsufr',
    countryCode: 'KW',
  },
  {
    desc: 'KWT-Jabriya',
    name: '5knop9v2',
    countryCode: 'KW',
  },
  {
    desc: 'KWT-Kitopi-Salmiya2',
    name: 'y5x1b936',
    countryCode: 'KW',
  },
  {
    desc: 'KWT-Kitopi-SAS',
    name: 'qnm4w5ou',
    countryCode: 'KW',
  },
  {
    desc: 'UAE-800pizza-DHCC',
    name: 'tt7d4wdv',
    countryCode: 'AE',
  },
  {
    desc: 'KWT-Kitopi-Ardiya3',
    name: 'q1avb96g',
    countryCode: 'KW',
  },
  {
    desc: 'QAT-DH-AbuHamour',
    name: 'un9l1wsf',
    countryCode: 'QA',
  },
  {
    desc: 'KWT-Kitopi-Fintas',
    name: 'hdfnozd3',
    countryCode: 'KW',
  },
  {
    desc: 'UAE-ChinChin-GlobalVillage',
    name: 'd0ahfwj4',
    countryCode: 'AE',
  },
  {
    desc: 'KWT-Kitopi-AAQ3',
    name: 'a0islo8y',
    countryCode: 'KW',
  },
  {
    desc: 'KWT-Kitopi-Shuhada',
    name: 'iyy2zc9l',
    countryCode: 'KW',
  },
  {
    desc: 'UAE-Taqado-Baysquare',
    name: '3bmk3j15',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CaliPoke-DIFC',
    name: 'yl5ku46f',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Zaroob-MotorCity',
    name: 'c9jkuypi',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Taqado-Townsquare',
    name: 'hxepc36u',
    countryCode: 'AE',
  },
  {
    desc: 'KWT-Kitopi-Warehouse',
    name: 'isi7aelv',
    countryCode: 'KW',
  },
  {
    desc: 'UAE-Taqado-DHM',
    name: 'ds0h3xhu',
    countryCode: 'AE',
  },
  {
    desc: 'BH-Kitopi-ZayedTown',
    name: '0btzafoc',
    countryCode: 'BH',
  },
  {
    desc: 'KSA-Kitopi-Worooad',
    name: '7oh4fvc8',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-FoodTrack',
    name: 'xa7xaojv',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-Kitopi-Alquoz (CK1)',
    name: 'znx2hnrk',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-800pizza-Sustainable',
    name: 'rfulczib',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-AD3',
    name: 'kpkrjxsy',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Zaroob-Marina',
    name: 'rjk3737q',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Zaroob-SZR',
    name: 'tt3s02p1',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-CK6',
    name: 'c0p5phx7',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Wokkong-Riviera',
    name: 'b6j274py',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-CaliPoke-DHM',
    name: 'tzo0qjrt',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-RightBite-VISA-HQ',
    name: 'v7gry283',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-JohnnyRockets-ForsanMall',
    name: 'unmpu2xw',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-Mirdif',
    name: 'cz69a2is',
    countryCode: 'AE',
  },
  {
    desc: 'QAT-DietHouse-Lagoona',
    name: '6c0lwyyd',
    countryCode: 'QA',
  },
  {
    desc: 'UAE-ChinChin-Baniyas',
    name: 'wi087k59',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-SK-Talabat-RAK',
    name: '95eco9qp',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-AljadaContainer',
    name: '09a8f9iz',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-DubaiMall',
    name: 'lwi8lh7f',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-FestivalCity',
    name: 'fuhchxpj',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Shobak-Panorama',
    name: 'zypgj3bk',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-SAFA-SK',
    name: 'vedwb019',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-Marwa',
    name: '4tt9njoa',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-RedseaMall',
    name: 'ap9x7eur',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-Obhur',
    name: '8zdjgfu9',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-CircleCafe-DWTC',
    name: 'ujix9jr8',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Shobak-Hamadaniyah',
    name: 'ah6kmbvw',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-CityWalk',
    name: '61gmotc8',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Wokkong-Villagemall',
    name: 'c8qrr1ev',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-Jview',
    name: '77qj3x70',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-AzizMall',
    name: 'brzm2osg',
    countryCode: 'SA',
  },
  {
    desc: 'KSA- Shobak Arabmall',
    name: 'd7uxog5t',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-Salammall',
    name: 'dl6erx8s',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-Teramall',
    name: 'gz0gqnlt',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-CPP',
    name: 'irksiktv',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-MakkahAwali',
    name: 'ks26ea66',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-Zahra',
    name: 'w8komuxq',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-Makkahmall',
    name: 'zj5zp1zv',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-ShawqiahMakkah',
    name: 'mjuytb7a',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-MamashaMadinah',
    name: 'wgeg1eit',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Shobak-Kingroad',
    name: 'ghyl6gn4',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-CaliPoke-RipeMarket',
    name: 'tcn4t63u',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Kitopi-Wokkong Khobar',
    name: 'ghwgzy6j',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-Kitopi-AD8',
    name: 'qxde7t6n',
    countryCode: 'AE',
  },
  {
    desc: 'PL HQ-Krakow',
    name: 'aepvsjm5',
    countryCode: 'PL',
  },
  {
    desc: 'KSA-Shobak-RiyadhPark',
    name: 'v90hjqrx',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-HighJoint-MC',
    name: '5sjv61q3',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HighJoint-EMT',
    name: 'tgea7yt0',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HighJoint-Manara',
    name: 'fz72vpkg',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HighJoint-KWN',
    name: '3p2i8qhk',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HighJoint-JLT',
    name: '404m19gd',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-OF-Townsquare',
    name: 'sxk720we',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-GoGreek-TownSquare',
    name: 'w11z7upe',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-Sahara',
    name: 'e0slurat',
    countryCode: 'AE',
  },
  {
    desc: 'KWT-Kitopi-AswaqCK',
    name: 'm0ecbzl3',
    countryCode: 'KW',
  },
  {
    desc: 'QAT-DH-BinOmranSK',
    name: 'uh3ud4uv',
    countryCode: 'QA',
  },
  {
    desc: 'QAT-DH-Semaisma',
    name: '9muqa5pr',
    countryCode: 'QA',
  },
  {
    desc: 'UAE-ChinChin-Burjman',
    name: 'wcn0qrs7',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinChin-DCC',
    name: 'oofyafgo',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Awani-DHM',
    name: '4tt2oa5i',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Wokkong-MOA',
    name: '3h3ear19',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-Talabat-Sharjah',
    name: 'o04lfpko',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Eatopi-DWTC',
    name: 'xemuihdi',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-OF-RiyadhPark',
    name: '3p00onh1',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-Kitopi-DIP',
    name: 'l8wax8ts',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Awani-Marina',
    name: 'ouisoq9a',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Kitopi-Nakheel',
    name: '653ouyg9',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-KavaChai-MOE',
    name: 'hhz1wm7f',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Shobak-Andalus',
    name: 'warubmgw',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Wokkong-Obhur',
    name: '4opn1ku6',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-SMK-Radisson-Palm',
    name: 'mkxx3bhh',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Awani-Meadows',
    name: 'm9roze1f',
    countryCode: 'AE',
  },
  {
    desc: 'BH-Zaroob-Marasi',
    name: '1u3f0opa',
    countryCode: 'BH',
  },
  {
    desc: 'UAE-KavaChai-SHJ',
    name: 'zdn2dkgn',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-OF-Galleria',
    name: 'ho39a90s',
    countryCode: 'AE',
  },
  {
    desc: 'KWT-RHS-Aasima',
    name: 'lr9yc3pl',
    countryCode: 'KW',
  },
  {
    desc: 'UAE-Chinchin-Mushrif',
    name: 'fqw5551j',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HOTBUN-Jumeirah',
    name: 'kdkbnej5',
    countryCode: 'AE',
  },
  {
    desc: 'KWT-RHS-Khairan',
    name: '743s9yad',
    countryCode: 'KW',
  },
  {
    desc: 'QAT-Kitopi-QNCC',
    name: 'f441297p',
    countryCode: 'QA',
  },
  {
    desc: 'KSA-AWANI-UWALK',
    name: 'nwrtgif4',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-GoGreek-Ripe',
    name: 'uwl4pbny',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-FlavourFields-WASL',
    name: '07h00k83',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Taqado-Yarmouk',
    name: 'syz25k85',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Taqado-Hitten',
    name: '2rdbsusw',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Catch22-UWALK',
    name: 'bx5l8fbn',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-OF-JoyAvenue',
    name: 'cfwbne3u',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Catch22-Tahlia',
    name: '7f9fos2w',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-Catch22-MCC',
    name: 'iruxc7hd',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-ChinChin-Malqa',
    name: 'd6pnhl7w',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Kitopi-NakheelWH',
    name: 'oel3f48x',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-ChinChin-Granada',
    name: '3h9f2oh4',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-CircleCafe-MarinaAUH',
    name: 'mb256na6',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-OF-DanPlaza',
    name: 'x3cyw7rd',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Taqado-Granada',
    name: 'ao6xp9f2',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-Awani-MAB',
    name: 'f6v7bffg',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Eatopi-DHM',
    name: 'or7omv7e',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CaliPoke-DXBIKES',
    name: 'yn9rg9i6',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-TAQADO-DXBIKES',
    name: 'pgi6mvm3',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Kitopi-Nargis',
    name: 'dht81g74',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-SMOKY-BEACH-PALM',
    name: '32y400wc',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-AWJ-CK',
    name: 'ik3wvqza',
    countryCode: 'AE',
  },
  {
    desc: 'UAECircleTaqado-AR3',
    name: '0cxzylr0',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Awani-NakheelMall',
    name: 'vb8jl2hz',
    countryCode: 'SA',
  },
  {
    desc: 'CaptivePortal_Internal',
    name: '8cepoov1',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-SHOBAK-RAWDAH',
    name: 'bo1ollss',
    countryCode: 'SA',
  },
  {
    desc: 'QAT-DietHouse-Thumama',
    name: '48ixi7zm',
    countryCode: 'QA',
  },
  {
    desc: 'UAE-C22-JBR',
    name: 't9xudjjw',
    countryCode: 'AE',
  },
  {
    desc: '--UNUSED--',
    name: 'default',
    countryCode: 'AE',
  },
  {
    desc: 'Test-Ali',
    name: 'r5fpzw1f',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HighJoint-BlueWaters',
    name: 'ayt3viub',
    countryCode: 'AE',
  },
  {
    desc: 'BH-AWANI-MARASI',
    name: 'j8mwdol0',
    countryCode: 'BH',
  },
  {
    desc: 'KWT-KITOPI-HeadOffice',
    name: 'bqtt9843',
    countryCode: 'KW',
  },
  {
    desc: 'KSA-Awani-NakheelMall',
    name: 'zyxfaw68',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-HighJoint-DubaiMall',
    name: '237jtsto',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Awani-RiyadhFront',
    name: 'cvd8d4dp',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-OF-Fayfa',
    name: '8yer8huq',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-OF-Ajdan',
    name: '6gc9ewgi',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-OF-Qadsiya',
    name: 'mbszmz1m',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-OF-Dammam',
    name: 'intxvwdm',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Catch22-NakheelMall',
    name: 'k5cr7q2a',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-OF-EPPCO',
    name: 'itklh83p',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Pizzaro-ALAIN',
    name: 'p8ru0o7v',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-OF-RubeenPlaza',
    name: 'p4ru8eg7',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-AWJ-CK',
    name: 'rq6dsbab',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-DK-DSO',
    name: 'ai46zehx',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-OF-Enoc',
    name: 'lm1ugsre',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-OF-DHM',
    name: 'rf9giajg',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Awani-Tahlia',
    name: '09u0ojhx',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-OF-AliaPlaza',
    name: 'c5hq9njb',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-Awani-DubaiMall',
    name: 'jasnlnt6',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Catch22-DHM',
    name: 'bo3lovut',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Awani-Zone',
    name: 'jbvyt883',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-Catch22-Zone',
    name: 'g3nj07fg',
    countryCode: 'SA',
  },
  {
    desc: 'KSA-OF-Centro',
    name: 'o51qejmn',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-OF-Boulevard',
    name: 'vk2c3bnl',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-OF-OutletVillage',
    name: 'gw2t3l40',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-OF-JBR',
    name: 'vvj68qb6',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-OF-MotorCity',
    name: 'ttohcdum',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-OF-MediaCity',
    name: 'lyjm0duv',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Awani-JBR',
    name: 'rshfh9fe',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-OF-AlDanah',
    name: 'h39hb5dk',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Catch22-ALZahia',
    name: 'zez0f68z',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-OF-Mercato',
    name: 'ieekri3h',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-Smoky-JBR',
    name: '1pyhmymd',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-OF-Tahlia',
    name: 'xjfnxdh8',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-ZAROOB-DCC',
    name: 'ctz9l0es',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-GoGreek-Ripe',
    name: 'nl385vbj',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HighJoint-MCC',
    name: 'tgbcmvvm',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HOTBUN-DHM',
    name: '8tcj5b0c',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HighJoint-AlZahia',
    name: 'v84r2msq',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Kitopi-UMALQ',
    name: '1uftf8za',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-PizzaroDHK-Ajman',
    name: 'b5kbl0w8',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ChinesePOD-JLT',
    name: 'l25gpql2',
    countryCode: 'AE',
  },
  {
    desc: 'KSA-Kitopi-Riyadh-WH2',
    name: 'u7aw4syf',
    countryCode: 'SA',
  },
  {
    desc: 'UAE-ArabicPOD-IMPZ',
    name: 'cqf19qaj',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-MexicanPOD-Deira',
    name: 'inmnnl1c',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-ItalianPOD-ALQouz',
    name: 'vw66ht35',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-HealthyPOD-ALQouz',
    name: 'e6hphzf6',
    countryCode: 'AE',
  },
  {
    desc: 'KWT-KitchenPark-Fahaheel',
    name: 'cg3t8led',
    countryCode: 'KW',
  },
  {
    desc: 'UAE-AWJWH-ALQUOZ',
    name: '69qk9hy3',
    countryCode: 'AE',
  },
  {
    desc: 'Alex-Test',
    name: 'ssl2pt0z',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Tawook-Nation-KP-IMPZ',
    name: 's0xwnk9k',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-FoodTruck-Pizzaro-DIP',
    name: 'z4qspe0c',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-FoodTruck-RightBite-DIP',
    name: 'o9zfaqer',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-FoodTruck-Sushido-DIP',
    name: '37htdsob',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-Template-Site',
    name: '6joa0chv',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-CircleCafe-JIP',
    name: 'x95w7n5s',
    countryCode: 'AE',
  },
  {
    desc: 'UAE-KPRightBite-Deira',
    name: '812j9rlj',
    countryCode: 'AE',
  },
];
